export const BACK_SLASH_N_REGEXP = /\n/gm
export const MULTIPLE_SPACE_REGEXP = /( )+/g
